import { useTheme } from "@mui/material/styles";
import React, { useEffect } from "react";
import LoginComponent from "../../../components/updated/authentication/loginEmail";
import { useLocation, useNavigate } from "react-router-dom";
import johnLight from "../../../assets/updated/auth/John Light mode.svg";
import johnDark from "../../../assets/updated/auth/John Dark Mode.svg";
import {
  baseNewCEXURL,
  baseLottoUrl,
  baseAcademyUrl,
  baseIndexxShopUrl,
  basePayUrl,
  baseIndexxWalletUrl,
} from "../../../services/api";
// @ts-ignore — zodiacAuth.js is plain JS, synced from zodiac-embed, no types
import { notifySignedOut } from "../../../components/ZodiacLauncher/zodiacAuth";

import { makeStyles } from "@mui/styles";
const useStyles = makeStyles((theme: any) => ({
  Container: {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme?.palette?.background.default,
    color: theme?.palette?.text?.primary,
    marginTop: "50px",
    gap: "10px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  orderBy: {
    [theme.breakpoints.down("md")]: {
      order: 2,
    },
  },
}));



const Login = () => {
  const theme = useTheme();
  const classes = useStyles();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const originalRedirectLink = searchParams.get("redirectWebsiteLink");
  const referralCode = searchParams.get("referralCode");


  let redirectWebsiteLink: any;
  if (originalRedirectLink === "exchange") {
    redirectWebsiteLink = baseNewCEXURL;
  } else if (originalRedirectLink === "lotto") {
    redirectWebsiteLink = baseLottoUrl;
  } else if (originalRedirectLink === "academy") {
    redirectWebsiteLink = baseAcademyUrl;
  } else if (originalRedirectLink === "shop") {
    redirectWebsiteLink = baseIndexxShopUrl;
  } else if (originalRedirectLink === "indexxpay") {
    redirectWebsiteLink = basePayUrl;
  } else if (originalRedirectLink === "indexxwallet") {
    redirectWebsiteLink = baseIndexxWalletUrl;
  }

  useEffect(() => {
    const action = searchParams.get("action");
    if (action === "Logout") {
      localStorage.removeItem("user"); // Remove one item
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("email");
      localStorage.clear(); // Clear all local storage
      /*
       * This is the estate's shared logout landing, not just ours: Lotto,
       * Academy and the Exchange all send the browser to
       * indexx.ai/auth/login?action=Logout to sign the user out. Clearing
       * localStorage here ended those sessions in this browser and nowhere
       * else — the Indexx ID session row and its first-party cookie survived,
       * so the launcher's silent check on the very next page found them and
       * signed the person straight back in, on the login page itself.
       *
       * notifySignedOut revokes the refresh family and navigates to
       * /session/end, which is what actually ends it. It goes LAST because it
       * navigates and may not come back, and it resolves false — never throws
       * — when no launcher client has been built on this page, in which case
       * the original redirect to /auth/login still happens, exactly as before.
       *
       * The provider returns to this origin's root rather than /auth/login:
       * only "/" is registered in indexx-web's post_logout_redirect_uris
       * (identity/src/config.js:107) and endSession matches that list exactly.
       */
      notifySignedOut()
        .catch(() => false)
        .then((ended: boolean) => {
          if (!ended) window.location.href = "/auth/login";
        });
    }
    // Already signed in -- now, or a moment later when the Indexx ID silent
    // check writes the session ("zodiac:session"): RedirectIfSignedIn
    // (App.tsx) sends them on to redirectWebsiteLink or home.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectWebsiteLink]);

  return (
    <div className={classes.Container}>
      {referralCode && referralCode === "zsuitepay" && (
        <div className={classes.orderBy} style={{ flex: 1 }}>
          <img
            src={theme.palette.mode === "dark" ? johnDark : johnLight}
            alt=""
            width={"95%"}
          />
        </div>
      )}

      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <LoginComponent
          redirectWebsiteLink={redirectWebsiteLink}
          referral={referralCode}
        />
      </div>
    </div>
  );
};

export default Login;
